// extracted by mini-css-extract-plugin
export default {"wrapper":"fallguysalternative_wrapper__b4jTM","button":"fallguysalternative_button__onbeW"};